export default {
    namespaced: true,
    state: {
        locations: null
    },
    getters: {
        locations: (state) => {
            return state.locations;
        },
        findLocation: (state) => (locationId) => {
            for(let index in state.locations) {
                if(state.locations.hasOwnProperty(index)) {
                    if(state.locations[index].id === locationId) {
                        return state.locations[index];
                    }
                }
            }
            return null;
        }
    },
    actions: {

    },
    mutations: {
        locations (state, locations) {
            state.locations = locations;
        }
    }
}